module.exports = __webpack_public_path__ + "img/introduce3.e80ab0af.png";